/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostCreateDocument extends ResponseREST {
  data: any[];
}

interface Body {
  idOutlet: number;
  idWasteCategory: number;
  idOutletCrew?: any;
  userId: string;
  name: string;
}

export const postCreateDocument = async (
  body: Body
): Promise<ResponseSuccessPostCreateDocument> => {
  return await axiosInstance
    .post('api/stock-waste-document-mobile/create-stock-waste', body)
    .then((res: AxiosResponse<ResponseSuccessPostCreateDocument>) => res.data);
};
